import { Component } from '@angular/core';

@Component({
  templateUrl: 'svg-3.component.html',
  standalone: true,
  selector: 'app-onboarding-svg-3',
})
export class Svg3Component {}
